import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { connect, useDispatch } from 'react-redux';
import SimpleForm from '../wizzard/contact';
import { SaveItem, itemError, UpdateItem, GetItem } from '../Reducers/items/actions';
import Publiceren from '../Components/Publiceren';
import SneaTabs from '../../../Components/SneaTabs';

const EditItemContact = ({ item, errors }) => {
  const [trcid, setTrcid] = useState([]);
  const [loading, setLoading] = useState(false);
  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (item._id && item.metadata.trcid === params.trcid) {
      setTrcid(item.metadata.trcid);
      setLoading(true);
    } else {
      dispatch(GetItem(params.trcid)).then((result) => {
        if (!result) {
          navigate("/items");
          alert("Kan item niet vinden");
        } else {
          setTrcid(result.metadata.trcid);
          setLoading(true);
        }
      });
    }
  }, [dispatch, item, navigate, params.trcid]);

  const submit = (vals) => {
    if (item._id) {
      const values = Object.assign({}, item, vals);
      dispatch(UpdateItem(item._id, values)).then(() => {
        if (item) {
          navigate("/items/edit/eigenschappen/" + trcid);
        }
      });
    } else {
      alert("Er is een fout gevonden.");
    }
  };

  const tabs = [
    { id: 'wat', label: 'Wat', content: <div>Wat content</div> },
    { id: 'waar', label: 'Waar', content: <div>Waar content</div> },
    { id: 'wanneer', label: 'Wanneer', content: <div>Wanneer content</div> },
    { id: 'media', label: 'Media', content: <div>Media content</div> },
    { id: 'contact', label: 'Contact', content: loading ? <SimpleForm onSubmit={submit} /> : <div>Loading...</div> },
    { id: 'eigenschappen', label: 'Eigenschappen', content: <div>Eigenschappen content</div> }
  ];

  const handleTabChange = (tabId) => {
    const routes = {
      'wat': `/items/edit/${trcid}`,
      'waar': `/items/edit/waar/${trcid}`,
      'wanneer': `/items/edit/wanneer/${trcid}`,
      'media': `/items/edit/media/${trcid}`,
      'contact': `/items/edit/contact/${trcid}`,
      'eigenschappen': `/items/edit/eigenschappen/${trcid}`
    };

    if (routes[tabId]) {
      navigate(routes[tabId]);
    }
  };

  if (item._id) {
    return (
        <div className="box box-default">
          <div className="box-header with-border">
            <h3 className="box-title">{item.what.title.value}</h3>
            <div className="box-tools pull-right">
              <Publiceren />
            </div>
          </div>
          <div className="box-body wizard">
            <SneaTabs
              tabs={tabs}
              defaultActiveTab={4}
              variant="default"
              onTabChange={handleTabChange}
            />
          </div>
        </div>
      );
    }
    return null;
  }

function mapStateToProps(state) {
  return { errors: state.auth.error, item: state.items.item };
}
export default connect(mapStateToProps, { SaveItem, itemError, UpdateItem, GetItem })(EditItemContact);
